import React from "react";
import "./styles.css";
import { pressArray } from "../../constants/contents";
import AnchorImage from "../UI/anchor-image";

function Press({ title }) {
  return (
    <div className="press">
      <h1>{title}</h1>
      <span>
        {pressArray.map((pressItem) => (
          <AnchorImage link={pressItem.link} image={pressItem.image} />
        ))}
      </span>
    </div>
  );
}

export default Press;
